import { GA } from 'types';
import getSelectItemEvent, { SelectItemEvent, SelectItemData } from './utils/getSelectItemEvent';
import getLoginEvent, { LoginEvent, LoginData } from './utils/getLoginEvent';
import getLogoutEvent, { LogoutEvent, LogoutData } from './utils/getLogoutEvent';
import getMenuClickEvent, { MenuClickEvent, MenuClickData } from './utils/getMenuClickEvent';
import getCTAClickEvent, { CTAClickData, CTAClickEvent } from './utils/getCTAClickEvent';

export type Data = SelectItemData | LoginData | LogoutData | MenuClickData | CTAClickData;

export type Event = SelectItemEvent | LoginEvent | LogoutEvent | MenuClickEvent | CTAClickEvent;

const getGAEvent = (data: Data): Event => {
  switch (data.type) {
    case GA.EventType.LOGIN:
      return getLoginEvent(data);
    case GA.EventType.LOGOUT:
      return getLogoutEvent(data);
    case GA.EventType.MENU_CLICK:
      return getMenuClickEvent(data);
    case GA.EventType.CTA_CLICK:
      return getCTAClickEvent(data);
    default:
      return getSelectItemEvent(data);
  }
};

export default getGAEvent;
